type calculateYearlyPaymentArgs = {
  loanAmount: number;
  loanDuration: number;
  interestRate: number;
  establishCost: number;
};
export function calculateYearlyPayment(args: calculateYearlyPaymentArgs) {
  const { establishCost, interestRate, loanAmount, loanDuration } = args;

  const totalLoanAmount = loanAmount + establishCost;

  if (!interestRate) return loanAmount / loanDuration + establishCost;

  return (
    (totalLoanAmount * interestRate) /
    (1 - Math.pow(1 + interestRate, -loanDuration))
  );
}
